import { render, staticRenderFns } from "./YueFuDetails.vue?vue&type=template&id=cea02884&scoped=true&"
import script from "./YueFuDetails.vue?vue&type=script&lang=js&"
export * from "./YueFuDetails.vue?vue&type=script&lang=js&"
import style0 from "./YueFuDetails.vue?vue&type=style&index=0&id=cea02884&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea02884",
  null
  
)

export default component.exports